/**
 * Venue addressing (BON-538).
 *
 * By record id, not slug. ⚠️ The plan called for `/admin/venues/<slug>`, and the
 * roster carries a `slug` for it, but the column is only populated for
 * Nebari-managed venues — a DB CHECK requires it for those and nothing fills it
 * for the rest — and `GET /api/v1/venues/:id` resolves a uuid only. Addressing
 * by slug today would produce dead links for most of the roster, so it waits
 * for a backend resolver and a venue-slug backfill.
 */
import type { VenueRosterRow } from './venues-roster-api';

export const venueHref = (venue: Pick<VenueRosterRow, 'id'>): string => `/admin/venues/${venue.id}`;
